import * as React from 'react';

export const Loading = ({
  size = 'normal',
  className = '',
}: {
  size?: 'small' | 'normal';
  className?: string;
}) => {
  const sizeClass = {
    small: 'h-3 w-3 border-[0.140625rem]',
    normal: 'h-4.5 w-4.5 border-[0.140625rem]',
  };
  return (
    <div className="flex justify-center" data-testid="loading">
      <div
        className={`animate-spinCustom rounded-full border-solid  border-neutral-b6 border-t-blue-500 ${sizeClass[size]} ${className}`}
      ></div>
    </div>
  );
};
